import React, {useEffect} from 'react'
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography} from "@mui/material";
import Subtitle from "../../components/Subtitle";
import {useTranslation} from "react-i18next";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {useAppDispatch} from "../../store/store";
import {sendEventsData} from "../../store/actions/actions";
const RecommendationLayout = () =>{
    const {t} =useTranslation();
    const dispatch = useAppDispatch();
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/detail/recommendation",
            type:"pageView"
        }))
    });
    return(
        <React.Fragment>
            <Box component="main">
                <Subtitle/>
                <br/>
                <br/>
                <Typography variant="h4" style={{fontWeight: "bold"}}>
                    {t('recommendation.title' as any)}
                </Typography>
                <br/>
                <Typography paragraph>
                    {t('recommendation.paragraph_1' as any)}
                </Typography>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Typography variant="h6">
                            {t('recommendation.section_1_title' as any)}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography paragraph>
                            {t('recommendation.section_1_description' as any)}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <Typography variant="h6">
                            {t('recommendation.section_2_title' as any)}
                          </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography paragraph>
                            {t('recommendation.section_2_description' as any)}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <Typography variant="h6">
                            {t('recommendation.section_3_title' as any)}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography paragraph>
                            {t('recommendation.section_3_description' as any)}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header">
                        <Typography variant="h6">
                            {t('recommendation.section_4_title' as any)}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography paragraph>
                            {t('recommendation.section_4_description' as any)}
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </React.Fragment>
    )
}
export default RecommendationLayout
